import styled from '@emotion/styled'

const GateForContentFormFieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 250px;
`

export default GateForContentFormFieldWrapper